module.exports = __webpack_public_path__ + "static/media/remove.420aa183.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/svg/remove.svg
// module id = 1038
// module chunks = 0